import {Observable} from 'rxjs';
import {Injectable} from '@angular/core';
import {Http, Headers, RequestOptionsArgs} from '@angular/http';
import {TOKEN_HEADER, TOKEN_HEADER_USERNAME, TOKEN_HEADER_PASSWORD} from '../../../../common/constants';

@Injectable()
export class LoginService {

    constructor(private _http: Http) {
    }

    login(credentials: {login: string, password: string}): Observable<any> {
        return this._http.post('/api/backoffice/token', {}, this.getRequestOptions(credentials))
            .map((request) => {
                const token = request.headers.get(TOKEN_HEADER);
                const body = request.json();

                return {
                    token,
                    expires: body.expireTimeMinutes
                }
            })
    }

    private getRequestOptions(credentials: {login: string, password: string}): RequestOptionsArgs {
        return {
            headers: new Headers({
                [TOKEN_HEADER_USERNAME]: credentials.login,
                [TOKEN_HEADER_PASSWORD]: credentials.password
            })
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/login/login.service.ts